import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAlertOctagon, FiRefreshCw } = FiIcons;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("iVivaCore UI Crash:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-red-50 flex items-center justify-center p-8">
          <div className="max-w-md w-full bg-white p-10 rounded-[3rem] shadow-2xl text-center border-4 border-red-100">
            <div className="w-20 h-20 bg-red-100 text-red-600 rounded-3xl flex items-center justify-center mx-auto mb-8">
              <SafeIcon icon={FiAlertOctagon} className="text-4xl" />
            </div>
            <h2 className="text-2xl font-black text-gray-900 mb-4">Dashboard Interrupted</h2>
            <p className="text-gray-500 mb-8 font-medium">
              A UI component failed to load, but your **Emergency Protocol 4422** remains active in the background.
            </p>
            <button 
              onClick={() => window.location.reload()}
              className="w-full py-4 bg-gray-900 text-white rounded-2xl font-bold flex items-center justify-center space-x-3 shadow-xl"
            >
              <SafeIcon icon={FiRefreshCw} />
              <span>Restore Dashboard</span>
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;